<template>
  <div :style="`min-height: ${minHeight}`">
    <div v-if="type === 'video'">
      <script 
        v-if="content.video.videohub_content"
        ref="player"
        :data-videohub-id="content.video.videohub_content" 
        :src="`https://evolucional.videohub.com.br/embed.js?${now}`" 
        type="module"
      />
      <iframe
        v-else
        :src="videoContent"
        :style="`
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  min-height: ${minHeight};
                `"
        class="top-0 bottom-0 w-100 h-100 left-0 right-0 h-100 border-0"
      />
    </div>
    <ModuleQuestionsComponent
      v-if="type === 'quiz'"
      :questions="content.quiz"
    />
    <ModulePageComponent
      v-if="type === 'page'"
      :page="content.page"
    />
  </div>
</template>
<script>
import ModuleQuestionsComponent from './ModuleQuestionComponent'
import ModulePageComponent from './ModulePageComponent'

export default {
  components: {
    ModuleQuestionsComponent,
    ModulePageComponent
  },
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    minHeight() {
      return "60vh"
    },
    videoContent() {
      return this.type === 'video'? this.content.video.videohub_content ? this.content.video.videohub_content : this.content.video.content : null
    },
    now(){
        return Date.now()
    },
    type() {
      if (this.content.is_video) return 'video'
      if (this.content.is_page) return 'page'
      else {
        return 'quiz'
      }
    }
  }
}
</script>
